import { openBlock as o, createElementBlock as t } from "vue";
import { _ as r } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const e = {
  compatConfig: { MODE: 3 },
  name: "DtDropdownSeparator"
}, a = {
  "aria-hidden": "true",
  class: "d-list-item-separator"
};
function n(s, c, p, i, _, d) {
  return o(), t("li", a);
}
const l = /* @__PURE__ */ r(e, [["render", n]]);
export {
  l as default
};
//# sourceMappingURL=dropdown-separator.js.map
